<script setup>
import { useGovernance } from '@/composables/useGovernance'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Governance',
  },
})

const { tree, loading, fetchOrganizationTree } = useGovernance()

onMounted(fetchOrganizationTree)
</script>

<template>
  <div>
    <h4 class="text-h4 font-weight-bold mb-1">
      Struktur Organisasi
    </h4>
    <p class="text-body-2 text-medium-emphasis mb-4">
      Hierarki Unit (§9.1) — untuk mengubah Unit, gunakan halaman Master Data &gt; Unit / Organisasi.
    </p>

    <VCard>
      <VCardText class="pa-6">
        <VProgressLinear
          v-if="loading"
          indeterminate
          color="primary"
          class="mb-3"
        />
        <OrgTree
          v-if="tree.length"
          :nodes="tree"
        />
        <p
          v-else-if="!loading"
          class="text-medium-emphasis text-center py-6 mb-0"
        >
          Belum ada data Unit.
        </p>
      </VCardText>
    </VCard>
  </div>
</template>
